import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TimeZoneInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    
    const modifiedReq = request.clone({
      // Ejemplo: Agregar encabezado de zona horaria
      setHeaders: {
       'Timezone': `${Intl.DateTimeFormat().resolvedOptions().timeZone}` 
      }
    });
    
    return next.handle(modifiedReq);
  }
}
